import React from 'react';
import { Link } from 'react-router-dom';
import AdminNav from '../components/admin/AdminNav';

export default function HomePage() {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const isAdmin = user?.role === 'superadmin' || user?.role === 'supplieradmin' || user?.isAdmin;

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center">
      {/* Admin Navigation */}
      {isAdmin && <AdminNav />}

      {/* Hero Section */}
      <header className="bg-white w-full shadow p-6 text-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">MeatShare</h1>
        <p className="text-gray-600 mt-2">
          Farm-fresh meat sharing, direct from local suppliers.
        </p>
        <Link to="/GroupSearchAndJoin">
          <button className="mt-4 bg-green-600 text-white px-5 py-2 rounded hover:bg-green-700 transition">
            Join a Group
          </button>
        </Link>
      </header>

      {/* How It Works Section */}
      <section className="bg-white w-full max-w-4xl shadow rounded p-6 mb-8">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">How It Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-gray-50 p-4 rounded shadow-sm">
            <h3 className="font-semibold text-gray-700 mb-2">1. Choose a Group</h3>
            <p className="text-gray-600">
              Find local beef, lamb, or pork groups to join.
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded shadow-sm">
            <h3 className="font-semibold text-gray-700 mb-2">2. Select Portion</h3>
            <p className="text-gray-600">
              Pick your percentage share and pay securely via Stripe.
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded shadow-sm">
            <h3 className="font-semibold text-gray-700 mb-2">3. Receive Your Meat</h3>
            <p className="text-gray-600">
              Pickup or delivery after the group is filled.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="text-gray-500 text-sm py-4 w-full text-center">
        &copy; {new Date().getFullYear()} MeatShare. All rights reserved.
      </footer>
    </div>
  );
}
